import type { CampaignCalendar } from '@roll1/shared';

/**
 * Deterministic calendar generation from world description.
 * Mirrors server/src/ai/llm/tools/timeline.tools.ts generateCalendarHandler.
 */
export function generateCalendarFromDescription(worldDescription: string): CampaignCalendar {
  const lower = worldDescription.toLowerCase();

  let name = 'World Calendar';
  let months: Array<{ name: string; days: number }>;
  let daysPerWeek = 7;
  let yearLabel = 'AE';
  let epoch = 'After Emergence';

  if (lower.includes('forgotten realms') || lower.includes('faerun') || lower.includes('фаэрун')) {
    name = 'Calendar of Harptos';
    months = [
      { name: 'Hammer', days: 30 }, { name: 'Alturiak', days: 30 },
      { name: 'Ches', days: 30 }, { name: 'Tarsakh', days: 30 },
      { name: 'Mirtul', days: 30 }, { name: 'Kythorn', days: 30 },
      { name: 'Flamerule', days: 30 }, { name: 'Eleasis', days: 30 },
      { name: 'Eleint', days: 30 }, { name: 'Marpenoth', days: 30 },
      { name: 'Uktar', days: 30 }, { name: 'Nightal', days: 30 },
    ];
    daysPerWeek = 10;
    yearLabel = 'DR';
    epoch = 'Dalereckoning';
  } else if (lower.includes('eberron') || lower.includes('эберрон')) {
    name = 'Calendar of Galifar';
    months = [
      { name: 'Zarantyr', days: 28 }, { name: 'Olarune', days: 28 },
      { name: 'Therendor', days: 28 }, { name: 'Eyre', days: 28 },
      { name: 'Dravago', days: 28 }, { name: 'Nymm', days: 28 },
      { name: 'Lharvion', days: 28 }, { name: 'Barrakas', days: 28 },
      { name: 'Rhaan', days: 28 }, { name: 'Sypheros', days: 28 },
      { name: 'Aryth', days: 28 }, { name: 'Vult', days: 28 },
    ];
    yearLabel = 'YK';
    epoch = 'Year of the Kingdom';
  } else {
    months = [
      { name: 'Frostmoon', days: 30 }, { name: 'Snowfall', days: 28 },
      { name: 'Thawing', days: 31 }, { name: 'Seedtime', days: 30 },
      { name: 'Blossom', days: 31 }, { name: 'Highsun', days: 30 },
      { name: 'Midsummer', days: 31 }, { name: 'Harvest', days: 30 },
      { name: 'Leaffall', days: 31 }, { name: 'Dimming', days: 30 },
      { name: 'Darknight', days: 30 }, { name: 'Yearsend', days: 28 },
    ];
  }

  return { name, months, daysPerWeek, yearLabel, epoch };
}
